/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Popconfirm,
} from 'antd';
import {
  DeleteOutlined, CheckOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import ResourceActions from '@Actions/production/resourceActions';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';

const ResourceGroups = ({
  user, getResourceGroup, getResourceGroupLoading, resourcesGroup, updateResourceGroup, updateResourceGroupLoading, deleteResourceGroup, deleteResourceGroupLoading,
}) => {
  const [call, setCall] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [data, setData] = useState([]);
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    getResourceGroup(user?.tenant_info?.org_id, '', (groups) => {
      setData(groups);
    });
  }, []);

  useEffect(() => {
    if (call) {
      getResourceGroup(user?.tenant_info?.org_id, '', (groups) => setData(groups));
    }
  }, [call]);

  const columns = [
    {
      title: 'RESOURCE GROUP NAME',
      editable: true,
      width: '250px',
      render: (text, record) => {
        const editable = record.resource_group_id === editingKey;
        return (
          <div className="resource-group__input">
            {(editable && isEditing) ? (
              <div style={{ width: '100%' }}>
                <H3FormInput
                  value={record.resource_group_name}
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(e) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData?.map((item) => {
                      if (item.resource_group_id === record?.resource_group_id) {
                        item.resource_group_name = e.target.value;
                      }
                      return data;
                    });
                    setData(copyData);
                    setGroupName(e.target.value);
                  }}
                  disabled={deleteResourceGroupLoading || getResourceGroupLoading || updateResourceGroupLoading}
                />
              </div>
            ) : (
              <Fragment>
                <div
                  className="resource-group__input"
                  onClick={() => {
                    setEditingKey(record?.resource_group_id);
                    setGroupName(record?.resource_group_name);
                    setIsEditing(true);
                  }}
                >
                  {record?.resource_group_name?.toProperCase()}
                </div>
              </Fragment>
            )}
          </div>
        );
      },
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      className: 'list__actions-column',
      render: (text, record) => {
        const editable = record.resource_group_id === editingKey;
        return (
          <Fragment>
            {(editable && isEditing) ? (
              <div className="list__actions">
                <div
                  className="list__actions-button"
                  onClick={() => {
                    const payload = {
                      resource_group_id: record?.resource_group_id,
                      resource_group_type: record?.resource_group_type,
                      org_id: user?.tenant_info?.org_id,
                      resource_group_name: groupName,
                    };
                    updateResourceGroup(payload, () => {
                      setCall(!call);
                      setIsEditing(false);
                      setGroupName('');
                    });
                  }}
                >
                  <CheckOutlined />
                </div>
              </div>
            ) : (
              <div className="list__actions">
                <Popconfirm
                  placement="topRight"
                  title="Are you sure you want remove this resource group?"
                  onConfirm={() => {
                    const payload = {
                      resource_group_id: record?.resource_group_id,
                    };
                    deleteResourceGroup(payload, () => {
                      setCall(!call);
                    });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <div
                    className="list__actions-button-delete"
                  >
                    <DeleteOutlined />
                  </div>
                </Popconfirm>
              </div>
            )}
          </Fragment>
        );
      },
      width: '40px',
    },
  ];

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    return copyData;
  };

  return (
    <Fragment>
      {/* Low rating reasons */}
      <div className="resource-group__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24">
            <div className="resource-group__table__wrapper">
              <Table
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <H3Text text={`${resourcesGroup?.data?.length || '0'} ${'Work Center(s)'}`} className="title" />
                  </div>
                )}
                loading={deleteResourceGroupLoading || getResourceGroupLoading || updateResourceGroupLoading}
                pagination={false}
                size="small"
                columns={columns}
                rowClassName="editable-row"
                dataSource={getDataSource(data || [])}
                // scroll={{ y: 'calc(100dvh - 170px)', x: 'max-content' }}
                bordered
                showHeader={false}
              />
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ResourceReducers }) => ({
  user: UserReducers.user,
  resourcesGroup: ResourceReducers.resourcesGroup,
  getResourceGroupLoading: ResourceReducers.getResourceGroupLoading,
  updateResourceGroupLoading: ResourceReducers.updateResourceGroupLoading,
  deleteResourceGroupLoading: ResourceReducers.deleteResourceGroupLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getResourceGroup: (orgId, searchKeyword, callback) => dispatch(ResourceActions.getResourceGroup(orgId, searchKeyword, callback)),
  updateResourceGroup: (payload, callback) => dispatch(ResourceActions.updateResourceGroup(payload, callback)),
  deleteResourceGroup: (payload, callback) => dispatch(ResourceActions.deleteResourceGroup(payload, callback)),
});

ResourceGroups.propTypes = {
  user: PropTypes.any,
  resourcesGroup: PropTypes.any,
  getResourceGroup: PropTypes.func,
  getResourceGroupLoading: PropTypes.bool,
  updateResourceGroup: PropTypes.func,
  deleteResourceGroup: PropTypes.func,
  updateResourceGroupLoading: PropTypes.bool,
  deleteResourceGroupLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResourceGroups));
